import { render } from "./HorsePreviewStudbooks.vue?vue&type=template&id=3527e013"
import script from "./HorsePreviewStudbooks.vue?vue&type=script&lang=js"
export * from "./HorsePreviewStudbooks.vue?vue&type=script&lang=js"

import "./HorsePreviewStudbooks.vue?vue&type=style&index=0&id=3527e013&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__